import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import { Dimensions, View, TouchableOpacity, Linking, ScrollView, Platform } from 'react-native'
import Carousel from 'react-native-snap-carousel'

import {
  VFScreen,
  Icon,
  VFText,
  VFImageHeader
} from '@vfgroup-oneplatform/foundation/Components'

import Embassies from '../Embassies'
import Card from '../../Components/Card'

import { getThemeImages } from '../../Themes/Modes/Helpers'

import styles from './CountryDetails.Styles'
import RoamingContext from '../../Context'

const SCREEN_WIDTH = Dimensions.get('screen').width

const CountryDetails = ({
  detailsProps
}) => {
  const {
    headerImage,
    capital,
    currency,
    prefix,
    emergencyContacts,
    embassiesOrConsulates
  } = detailsProps

  const {
    onClose,
    theme,
    setScreen: screenStateChange,
    selectedCountry
  } = useContext(RoamingContext)?.roamingState

  const Images = getThemeImages(theme.name)

  if (Platform.OS === 'web' && Dimensions.get('window').width > 700) {
    return (
      <VFScreen
        title={selectedCountry.name}
        onClose={onClose}
        withHeader={false}
      >
        {/* <View> */}
        <VFImageHeader
          title={selectedCountry.name}
          onClose={onClose}
          image={{ uri: headerImage }}
          imageStyle={{ borderBottomWidth: 2, borderColor: 'grey' }}
          withOverlay={false}
          titleStyle={styles.headerTitle}
          leftIcon={Images.backWhite}
          rightIcon={Images.closeWhite}
          showBack
          onBack={() => screenStateChange({ screen: 'COUNTRY_ROAMING' })}
        />
        <ScrollView>
          <View style={[styles.paddingHorizontal20, { paddingHorizontal: '10%' }]}>
            <VFText
              i18nKey={'roaming_country_details_title'}
              style={styles.title}
            />

            {/* General Information */}
            <View style={styles.detailsContainer}>
              <VFText
                i18nKey={'roaming_country_details_capital'}
                style={styles.detailsTitle}
              />
              <VFText i18nKey={capital} style={styles.fontSize18} />
            </View>
            <View style={styles.detailsContainer}>
              <VFText
                i18nKey={'roaming_country_details_currency'}
                style={styles.detailsTitle}
              />
              <VFText i18nKey={currency} style={styles.fontSize18} />
            </View>
            <View style={styles.detailsContainer}>
              <VFText
                i18nKey={'roaming_country_details_prefix'}
                style={styles.detailsTitle}
              />
              <VFText i18nKey={prefix} style={styles.fontSize18} />
            </View>

            {/* Emergency information section */}


            {emergencyContacts.length > 0 &&
              <>
                <VFText
                  i18nKey={'roaming_country_details_emergencySectionTitle'}
                  style={styles.title}
                />
                <div style={{}}>
                  {emergencyContacts.map((item) => {
                    return (
                      <TouchableOpacity
                        onPress={() => {
                          Linking.openURL(`tel:${item.phoneNumber}`)
                        }}
                      >
                        <Card style={styles.margin0} theme={theme}>
                          <View style={styles.displayFlex}>
                            <Icon
                              name={Images.phone}
                              size={19}
                              style={styles.carouselCardIcon}
                            />
                            <VFText
                              i18nKey={item.title}
                              style={styles.carouselCardTitle}
                            />
                          </View>

                          <View style={styles.carouselCardPhoneInfoContainer}>
                            <VFText
                              i18nKey={item.phoneNumber}
                              style={styles.carouselPhoneTitle}
                            />
                            <VFText
                              i18nKey={'roaming_country_details_free_to_call'}
                              style={[
                                styles.fontSize18,
                                styles.carouselCardPhoneCallPrice
                              ]}
                            />
                          </View>

                          {/* <VFText
                                            i18nKey={item.description}
                                            style={styles.carouselCardPhoneCallPrice}
                                          /> */}
                        </Card>
                      </TouchableOpacity>
                    )
                  })}
                </div>

                {/* <Carousel
                  layout={'default'}
                  activeSlideAlignment={'start'}
                  activeSlideOffset={10}
                  callbackOffsetMargin={7}
                  enableSnap={true}
                  data={emergencyContacts}
                  sliderWidth={SCREEN_WIDTH}
                  itemWidth={SCREEN_WIDTH / 1.5}
                  renderItem={({ item }) => {
                  }}
                /> */}
              </>
            }



            {/* Consulates and Embassies Section */}
            {
              embassiesOrConsulates?.map(item => {
                if (!item.type) {
                  return
                }
                if (item.type === 'embassy') {
                  return (
                    <Embassies
                      style={styles.embassiesStyles}
                      title={'roaming_embassies_title'}
                      data={item}
                      theme={theme}
                    />
                  )
                } else {
                  return (
                    <Embassies
                      style={styles.embassiesStyles}
                      title={'roaming_embassies_consulates_title'}
                      data={item}
                      theme={theme}
                    />
                  )
                }
              })
            }

          </View>
        </ScrollView>
        {/* </View> */}
      </VFScreen>
    )
  }

  return (
    <VFScreen
      title={selectedCountry.name}
      onClose={onClose}
      withHeader={false}
    >
      {/* <View> */}
      <VFImageHeader
        title={selectedCountry.name}
        onClose={onClose}
        image={{ uri: headerImage }}
        imageStyle={{ borderBottomWidth: 2, borderColor: 'grey' }}
        withOverlay={false}
        titleStyle={styles.headerTitle}
        leftIcon={Images.backWhite}
        rightIcon={Images.closeWhite}
        showBack
        onBack={() => screenStateChange({ screen: 'COUNTRY_ROAMING' })}
      />
      <ScrollView>
        <View style={styles.paddingHorizontal20}>
          <VFText
            i18nKey={'roaming_country_details_title'}
            style={styles.title}
          />

          {/* General Information */}
          <View style={styles.detailsContainer}>
            <VFText
              i18nKey={'roaming_country_details_capital'}
              style={styles.detailsTitle}
            />
            <VFText i18nKey={capital} style={styles.fontSize18} />
          </View>
          <View style={styles.detailsContainer}>
            <VFText
              i18nKey={'roaming_country_details_currency'}
              style={styles.detailsTitle}
            />
            <VFText i18nKey={currency} style={styles.fontSize18} />
          </View>
          <View style={styles.detailsContainer}>
            <VFText
              i18nKey={'roaming_country_details_prefix'}
              style={styles.detailsTitle}
            />
            <VFText i18nKey={prefix} style={styles.fontSize18} />
          </View>

          {/* Emergency information section */}

          {emergencyContacts.length > 0 &&
            <>
              <VFText
                i18nKey={'roaming_country_details_emergencySectionTitle'}
                style={styles.title}
              />
              <Carousel
                layout={'default'}
                activeSlideAlignment={'start'}
                activeSlideOffset={10}
                callbackOffsetMargin={7}
                enableSnap={true}
                data={emergencyContacts}
                sliderWidth={SCREEN_WIDTH}
                itemWidth={SCREEN_WIDTH / 1.5}
                renderItem={({ item }) => {
                  return (
                    <TouchableOpacity
                      onPress={() => {
                        Linking.openURL(`tel:${item.phoneNumber}`)
                      }}
                    >
                      <Card style={styles.margin0} theme={theme}>
                        <View style={styles.displayFlex}>
                          <Icon
                            name={Images.phone}
                            size={19}
                            style={styles.carouselCardIcon}
                          />
                          <VFText
                            i18nKey={item.title}
                            style={styles.carouselCardTitle}
                          />
                        </View>

                        <View style={styles.carouselCardPhoneInfoContainer}>
                          <VFText
                            i18nKey={item.phoneNumber}
                            style={styles.carouselPhoneTitle}
                          />
                          <VFText
                            i18nKey={'roaming_country_details_free_to_call'}
                            style={[
                              styles.fontSize18,
                              styles.carouselCardPhoneCallPrice
                            ]}
                          />
                        </View>

                        {/* <VFText
                        i18nKey={item.description}
                        style={styles.carouselCardPhoneCallPrice}
                      /> */}
                      </Card>
                    </TouchableOpacity>
                  )
                }}
              />
            </>
          }



          {/* Consulates and Embassies Section */}
          {
            embassiesOrConsulates?.map(item => {
              if (!item.type) {
                return
              }
              if (item.type === 'embassy') {
                return (
                  <Embassies
                    style={styles.embassiesStyles}
                    title={'roaming_embassies_title'}
                    data={item}
                    theme={theme}
                  />
                )
              } else {
                return (
                  <Embassies
                    style={styles.embassiesStyles}
                    title={'roaming_embassies_consulates_title'}
                    data={item}
                    theme={theme}
                  />
                )
              }
            })
          }

        </View>
      </ScrollView>
      {/* </View> */}
    </VFScreen>
  )
}

CountryDetails.defaultProps = {}

CountryDetails.propTypes = {
  detailsProps: PropTypes.object
}

export default CountryDetails
